import * as Mui from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useSnackbar from "../../../hooks/useSnackbar";
import OperationTypes from "../../../types";
import VehicleEntranceService, {
  EnumStatusReasons,
} from "../service/VehicleEntranceService";

interface Props {
  open: boolean;
  onClose: () => void;
  vehicleId: number;
}

const ChangeStatus = (props: Props) => {
  const { tenant } = useContext(ContextOperation);

  const navigate = useNavigate();

  const [statusReasons, setStatusReasons] = useState<OperationTypes.Domain[]>(
    []
  );
  const [currentStatus, setCurrentStatus] = useState<string>("");

  const snackbar = useSnackbar();
  const t = useOperationTranslation();
  const { setLoading } = useContext(ContextOperation);

  useEffect(() => {
    VehicleEntranceService.firstFueling.get
      .availabilityStatusReasons(tenant, EnumStatusReasons.AVAILABLE, false)
      .then((response) => setStatusReasons(response));
  }, []);

  useEffect(() => {
    if (props.open) {
      if (!props.vehicleId) {
        props.onClose();
        return;
      }

      VehicleEntranceService.firstFueling.get
        .unavailabilityByVehicle(tenant, props.vehicleId)
        .then((response) => {
          setCurrentStatus(
            response?.availabilityHistory?.availabilityCode || ""
          );
        });
    }
  }, [props.open]);

  const onChangeStatus = (availabilityCode: string) => {
    if (availabilityCode === currentStatus) {
      navigate("/operation/transfer/vehiclesEntrance");
      props.onClose();
      return;
    }
    setLoading(true);
    VehicleEntranceService.firstFueling.post
      .changeAvailabilityReason(tenant, props.vehicleId, availabilityCode)
      .then(
        (response) => {
          snackbar.show(
            "success",
            t("vehicleAvailability.status.changeAvailabilityStatus.succesfull")
          );
          setLoading(false);
          navigate("/operation/transfer/vehiclesEntrance");
        },
        (reject) => {
          snackbar.show(
            "error",
            t("vehicleAvailability.status.changeAvailabilityStatus.error")
          );
          setLoading(false);
          props.onClose();
        }
      );
  };

  return (
    <Mui.Dialog open={props.open}>
      <Mui.DialogContent>
        <Mui.Typography textAlign="center" variant="h6">
          {t("vehicleAvailability.status.changeAvailabilityStatus.title")}
        </Mui.Typography>

        <Mui.Stack gap={2} mt={2.5}>
          {statusReasons.map((status) => {
            const isActive = currentStatus === status.code;
            return (
              <Mui.Button
                variant="contained"
                color={isActive ? "primary" : "accent"}
                onClick={() => onChangeStatus(status.code)}
              >
                {status.descr}
              </Mui.Button>
            );
          })}
        </Mui.Stack>
      </Mui.DialogContent>
    </Mui.Dialog>
  );
};

export default ChangeStatus;
